import { Block } from "@/components/Block/Block";
import { Epic } from "@/components/Epic/Epic";
import { Filter } from "@/components/Filter/Filter";
import { FlexWrapper } from "@/components/FlexWrapper/FlexWrapper";
import { Services } from "@/components/Services/Services";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import s from "./style.module.scss";
import { Header } from "@/components/Header/Header";
import { JoyrideTooltips } from "@/components/JoyrideTooltips/JoyrideTooltips";

export const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const hasCompletedOnboarding = localStorage.getItem(
      "hasCompletedOnboarding"
    );
    if (!hasCompletedOnboarding) {
      navigate("/onboarding", { replace: true });
    }
  }, []);

  return (
    <>
      <JoyrideTooltips />
      <FlexWrapper className={s.flexWrapper}>
        <Block
          borderRadius="bottom"
          className={s.header}
        >
          <Header title="FL.ru" />
        </Block>
        <Filter />
        <Block
          borderRadius="top"
          wihoutPadding
          className={s.services}
        >
          <Services />
        </Block>
      </FlexWrapper>
      <Epic />
    </>
  );
};
